var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('in-toast'),_c('in-progress'),_c('in-menu'),_c('v-content',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","grid-list-sm":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }